import { FC, useMemo } from 'react';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import styles from './index.module.scss';

import { TEXTS } from '../../texts';
import { useSelectPointsGroupPointsViewModel } from './useSelectPointsGroupPointsViewModel';
import PointGroupPointsList from '../../PointsGroupDrawer/PointsGroupsPointsList';

interface ISelectPointsGroupPointsProps {
  close: () => void;
}

const SelectPointsGroupPoints: FC<ISelectPointsGroupPointsProps> = ({ close }) => {
  const {
    allPointList,
    loadMore,
    selectedPoints,
    onPointsChange,
    isButtonDisabled,
    updatePointsGroup,
    isButtonLoading,
    onNext,
    onBack,
  } = useSelectPointsGroupPointsViewModel();

  const { isIpad } = useMedia();

  const actionButtons = useMemo(
    () => [
      <Button
        key="button_bind_video_stream_modal"
        elementId="button_bind_video_stream_modal"
        type={ButtonType.PRIMARY}
        isLoading={isButtonLoading}
        onClick={onNext}
        isDisabled={isButtonDisabled}>
        {TEXTS.NEXT}
      </Button>,
      <Button
        key="button_bind_video_stream_modal_close"
        elementId="button_bind_video_stream_modal_close"
        type={ButtonType.SECONDARY}
        onClick={onBack}
        isDisabled={isButtonLoading}>
        {TEXTS.BACK}
      </Button>,
    ],
    [isButtonLoading, isButtonDisabled]
  );

  return (
    <ModalScreen
      title={TEXTS.MODAL_SELECT_POINTS_TITLE}
      titlePlacement="left"
      disableScroll={!isIpad}
      contentClassName={styles.VideoStreamBindModalContent}
      onClose={close}
      actionButtons={actionButtons}>
      <PointGroupPointsList
        points={allPointList.points || []}
        isLoading={allPointList.isReloading}
        loadMore={loadMore}
        onChange={onPointsChange}
        selectedPoints={selectedPoints}
      />
    </ModalScreen>
  );
};

export default SelectPointsGroupPoints;
